import {useMemo, useState} from 'react';

const pageSizeOptions = {
  'ten': 10,
  'fifty': 50,
  'all': -1,
} as const;

export const useTablePagination = () => {
  const [pagination, setPagination] = useState<{pageIndex: number; pageSize: 10 | 50 | typeof Infinity}>({
    pageIndex: 0,
    pageSize: pageSizeOptions.ten,
  });

  // const getActualPageSize = (selectedSize: number) => {
  //   return pagination.pageSize === -1 ? Number.MAX_SAFE_INTEGER : selectedSize;
  // };

  const currentPageSize = useMemo(() => {
    if (pagination.pageSize === -1) return Number.MAX_SAFE_INTEGER;
    return pagination.pageSize;
  }, [pagination.pageSize]);

  return {
    pagination,
    setPagination,
    currentPageSize,
  };
};
